import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TherapiesActionCreatorService} from "@ispm/therapies/services/therapies-action-creator.service";
import {Observable} from "rxjs";
import {filter, map, take} from "rxjs/operators";
import {IRevision} from "@ispm/core/interfaces/workflow.interface";
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'ispm-pathway-treatments-list',
  templateUrl: './pathway-treatments-list.component.html',
  styleUrls: ['./pathway-treatments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PathwayTreatmentsListComponent implements OnInit {
  public treatments$: Observable<string[]>;
  public readonly offPathwayKey = 'off_pathway';
  @Input() revision: IRevision;

  constructor(
    private therapiesAC: TherapiesActionCreatorService,
    private translateService: TranslateService
    ) {
  }

  ngOnInit() {
    this.treatments$ = this.therapiesAC.getReviews()
      .pipe(
        filter(reviews => !!reviews && reviews[0] && reviews[0].priority),
        map(reviews => !!reviews && (reviews instanceof Array) && reviews.length > 0
          ? reviews[0].priority.map(
              priorityObject => (priorityObject.treatmentPlanName && priorityObject.modified
                ? priorityObject.treatmentPlanName + ' (' + this.translateService.instant('MODIFIED') + ')'
                : priorityObject.treatmentPlanName
              ) || this.offPathwayKey
            )
          : ''
        )
      );
  }

}
